import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface ILiveChatIconProps extends ISvgIconProps {

}

export class LiveChatIcon extends React.Component<ILiveChatIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M18.196 9.923h-1.2v-1.458a3.445 3.445 0 0 0 -1.425 -2.686 5.81 5.81 0 0 0 -3.61 -1.181 5.81 5.81 0 0 0 -3.609 1.18 3.445 3.445 0 0 0 -1.425 2.686v1.458h-1.2v-1.458c0 -2.794 2.796 -5.066 6.234 -5.066s6.234 2.272 6.234 5.066Z"/>
                    <path d="M10.96 20.176a4.845 4.845 0 0 1 -4.839 -4.839h1.2A3.643 3.643 0 0 0 10.96 18.976Z"/>
                    <path d="M11.75 17.921a1.617 1.617 0 1 1 -1.617 1.617 1.619 1.619 0 0 1 1.617 -1.617Zm0 2.034a0.417 0.417 0 1 0 -0.417 -0.418 0.418 0.418 0 0 0 0.417 0.418Z"/>
                    <path d="M4.8 9.728a0.4 0.4 0 0 0 -0.4 0.4v3.6a0.4 0.4 0 0 0 0.4 0.4h0.577a0.4 0.4 0 0 0 0.4 -0.4v-3.6a0.4 0.4 0 0 0 -0.4 -0.4H4.8m0 -1.2h0.577a1.6 1.6 0 0 1 1.6 1.6v3.6a1.6 1.6 0 0 1 -1.6 1.6H4.8a1.6 1.6 0 0 1 -1.6 -1.6v-3.6a1.6 1.6 0 0 1 1.6 -1.6Z"/>
                    <path d="M18.395 9.728a0.4 0.4 0 0 0 -0.4 0.4v3.6a0.4 0.4 0 0 0 0.4 0.4h0.577a0.4 0.4 0 0 0 0.4 -0.4v-3.6a0.4 0.4 0 0 0 -0.4 -0.4h-0.577m0 -1.2h0.577a1.6 1.6 0 0 1 1.6 1.6v3.6a1.6 1.6 0 0 1 -1.6 1.6h-0.577a1.6 1.6 0 0 1 -1.6 -1.6v-3.6a1.6 1.6 0 0 1 1.6 -1.6Z"/>
                </g>
            </SvgIcon>
        );
    }
}
